/* "You may also like" -- loads the full matching collection (not just a
   handful) in batches via the Section Rendering API, so pages with
   thousand-plus-product collections (Beds, Sectionals, etc.) stay fast on
   first paint while the whole collection remains reachable via Load more. */
(function () {
  if (customElements.get('dc-related-collection')) return;

  class DcRelatedCollection extends HTMLElement {
    connectedCallback() {
      this.grid = this.querySelector('[data-grid]');
      this.addEventListener('click', this._onClick.bind(this));
    }

    _onClick(event) {
      var btn = event.target.closest('[data-load-more]');
      if (!btn) return;
      this._loadMore(btn);
    }

    _loadMore(btn) {
      var nextUrl = btn.getAttribute('data-next-url');
      var sectionId = this.getAttribute('data-section-id');
      if (!nextUrl || !sectionId || btn.disabled) return;

      btn.disabled = true;
      var originalText = btn.textContent;
      btn.textContent = 'Loading…';

      var sep = nextUrl.indexOf('?') > -1 ? '&' : '?';
      fetch(nextUrl + sep + 'section_id=' + sectionId)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var tmp = document.createElement('div');
          tmp.innerHTML = html;

          var freshGrid = tmp.querySelector('[data-grid]');
          if (freshGrid && this.grid) {
            Array.from(freshGrid.children).forEach(function (child) {
              this.grid.appendChild(child);
            }, this);
          }

          var freshBtn = tmp.querySelector('[data-load-more]');
          var wrap = btn.closest('[data-load-more-wrap]');
          if (freshBtn) {
            btn.setAttribute('data-next-url', freshBtn.getAttribute('data-next-url'));
            btn.disabled = false;
            btn.textContent = originalText;
          } else if (wrap) {
            wrap.remove();
          }
        }.bind(this))
        .catch(function () {
          btn.disabled = false;
          btn.textContent = originalText;
        });
    }
  }

  customElements.define('dc-related-collection', DcRelatedCollection);
})();
